import React, { Component } from 'react';
import DockPanel from './DockPanel/DockPanel';
import Web3 from "web3";
import {Button, Tabs, Tab, Card, Row, Col, Spinner} from "react-bootstrap"
import CreateNewProjectButton from "./CreateNewProjectButton";
import ProjectThumbnail from "./ProjectThumbnail/ProjectThumbnail";
import MarkdownPreview from '@uiw/react-markdown-preview';

class AboutPlatformModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      aboutModalLoading: true,
      currentPage: 1,
      projectsPerPage: 6, // 3 wide x 2 tall
    }
  }

  updateAndNotify = async () => {
    this.setState({aboutModalLoading: true})

    const { contract, projects } = this.props;
    if (!projects || projects.length === 0) {
      this.setState({aboutModalLoading: false});
      return;
    }

    let projectIdToPricePerEditionInEth = [];
    let projectIdToImageURLBase = [];
    let projectIdToImageURLExt = [];
    let tokenIdsForProjectId = [];

    if (contract) {
      for(let i = 0; i < projects.length; i++) {
        let price = await contract.methods.projectIdToPricePerEditionInWei(i+1).call();
        let base = await contract.methods.projectIdToImageURLBase(i+1).call();
        let ext = await contract.methods.projectIdToImageURLExt(i+1).call();
        let tokenIds = await contract.methods.getTokenIdsForProjectId(i+1).call();

        let priceInEth = Web3.utils.fromWei(price, 'ether')
        projectIdToPricePerEditionInEth.push(priceInEth);

        projectIdToImageURLBase.push(base);
        projectIdToImageURLExt.push(ext);
        tokenIdsForProjectId.push(tokenIds);
      }
    } else {
      // Archive/offline mode — use placeholder data so project cards render
      for(let i = 0; i < projects.length; i++) {
        projectIdToPricePerEditionInEth.push("0");
        projectIdToImageURLBase.push("");
        projectIdToImageURLExt.push("");
        tokenIdsForProjectId.push([]);
      }
    }

    this.setState({
      projectIdToPricePerEditionInEth,
      projectIdToImageURLBase,
      projectIdToImageURLExt,
      tokenIdsForProjectId,
      aboutModalLoading: false,
    })
  }

  componentDidMount() {
    if (this.props.isAboutPlatformOpen) {
      this.updateAndNotify();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isAboutPlatformOpen &&
        (!prevProps.isAboutPlatformOpen || prevProps.projects !== this.props.projects)) {
      this.updateAndNotify();
    }
  }

 render() {
    const { isAboutPlatformOpen, closeAboutPlatformModal,
            userIsAuthorizedArtist, artistScreeningEnabled,
            platform, contract, projects, setProjectId} = this.props;

    const { projectIdToPricePerEditionInEth, projectIdToImageURLBase, tokenIdsForProjectId, projectIdToImageURLExt, aboutModalLoading, currentPage, projectsPerPage} = this.state;

    // Filter active projects and calculate pagination
    const activeProjects = projects ? projects.map((p, i) => ({...p, originalIndex: i})).filter(p => p.active) : [];
    const totalPages = Math.ceil(activeProjects.length / projectsPerPage);
    const startIndex = (currentPage - 1) * projectsPerPage;
    const paginatedProjects = activeProjects.slice(startIndex, startIndex + projectsPerPage);

    const panelFooter = (
      <>
        {(contract && contract.options) ? (
          <>
          <Button variant="outline-secondary btn-sm" className="font-display" onClick={() => window.open(`${platform.etherscan_link}${contract.options.address}`)}>etherscan</Button>
          </>
        ) : ("")}
          <Button variant="secondary btn-sm"  className="font-display" onClick={closeAboutPlatformModal}> close </Button>
      </>
    );

    return (
      <DockPanel
        show={isAboutPlatformOpen}
        onClose={closeAboutPlatformModal}
        title={<>about {platform.name}</>}
        storageKey="about"
        unstyled
        defaultWidth={940}
        defaultHeight={680}
        minWidth={360}
        minHeight={240}
        footer={panelFooter}
      >
        <div className="dock-panel__pad">
        <p></p>
        {platform.description}
        <p></p>
        <div className="mb-3" style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem'}}>
          <Button variant="outline-secondary" className="font-display" href="https://immutables.art/docs/" target="_blank" rel="noopener noreferrer">documentation</Button>
          <span>Guides for collectors, artists &amp; coders, galleries &amp; museums.</span>
        </div>
        <Tabs defaultActiveKey="active_projects" id="uncontrolled-tab-example">

          <Tab eventKey="active_projects" title="Active Projects">
          { (aboutModalLoading) ? (
            <>
            <p></p>
            <div align="center">Loading active projects...</div>
            <div align="center"><Spinner animation="grow" /></div>
            </>
          ) : (
            <>
            <p></p>
            <Row xs={1} md={3} className="g-3">
            {
              (projectIdToPricePerEditionInEth && tokenIdsForProjectId) ? (
                 paginatedProjects.map((project) => {
                   const i = project.originalIndex;
                   const hasTokens = tokenIdsForProjectId[i] && tokenIdsForProjectId[i].length > 0;
                   const randomTokenId = hasTokens ? tokenIdsForProjectId[i][Math.floor(Math.random()*tokenIdsForProjectId[i].length)] : null;
                   const imgSrc = hasTokens ? `${projectIdToImageURLBase[i]}/${randomTokenId}${projectIdToImageURLExt[i]}` : null;
                   return (
                       <Col key={i}>
                         <Card className="bg-dark text-white" style={{width: "100%", aspectRatio:"1/1", overflow: "hidden", cursor: "pointer"}}
                          onClick={() => setProjectId(i+1)}>
                           <div style={{position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden"}}>
                             <ProjectThumbnail
                               project={project}
                               getProjectScript={this.props.getProjectScript}
                               fallbackSrc={imgSrc}
                             />
                           </div>
                           <Card.ImgOverlay className="overlay-dark" style={{display: "flex", flexDirection: "column", justifyContent: "flex-end", background: "linear-gradient(transparent 40%, rgba(0,0,0,0.8))"}}>
                             <Card.Title style={{fontSize: "0.9rem", marginBottom: "0.25rem"}}>{project.name}</Card.Title>
                             <Card.Text style={{fontSize: "0.75rem", marginBottom: "0.15rem"}}>by {project.artist}</Card.Text>
                             <Card.Text style={{fontSize: "0.7rem", marginBottom: "0"}}>
                              {projectIdToPricePerEditionInEth[i]}Ξ ({project.currentEditionId}/{project.maxEditions})
                             </Card.Text>
                           </Card.ImgOverlay>
                         </Card>
                       </Col>
                   );
                 })
               ) : ("")
             }
             </Row>
            {/* Pagination controls */}
            {totalPages > 1 && (
              <div align="center" style={{marginTop: "1rem"}}>
                <Button
                  variant="outline-secondary btn-sm"
                  className="font-display" style={{marginRight: "0.5rem"}}
                  disabled={currentPage === 1}
                  onClick={() => this.setState({currentPage: currentPage - 1})}
                >&lt; prev</Button>
                <span style={{margin: "0 0.5rem"}}>{currentPage} / {totalPages}</span>
                <Button
                  variant="outline-secondary btn-sm"
                  className="font-display" style={{marginLeft: "0.5rem"}}
                  disabled={currentPage === totalPages}
                  onClick={() => this.setState({currentPage: currentPage + 1})}
                >next &gt;</Button>
              </div>
            )}
            <p></p>
            </>
          )}
          </Tab>

          <Tab eventKey="about_platform_how_it_works" title="How Does This Work?">
              <p></p>
              <b>Immutables.art is completely serverless.</b> There is no backend server. All art code and project data are stored on the Ethereum blockchain, and the artwork is rendered directly in your browser. Here is how each part works:

              <div className="how-it-works-panel">

              <b>1. Artist: Store Code &amp; Create a Project</b>
              <p style={{marginTop: '0.5rem'}}>
                The artist mints their own <a href="http://immutables.co" target="_blank" rel="noopener noreferrer">Immutables.co</a> NFT page and posts their generative art script (p5.js, three.js, vanilla JS, or GLSL code) into it. This stores the code permanently on-chain in the transaction log, and the artist owns the page as their own NFT. The artist then takes the transaction hash of that code post and uses it to create a new project on the Immutables.art smart contract. This links the on-chain art code to the project.
              </p>
              <div style={{textAlign: 'center'}}><img src={`${process.env.PUBLIC_URL}/2022-01-29-Immutables_v4-Detailed_Diagram_Artist_1.png`} alt="Diagram: Artist stores code on-chain and creates a project" width="70%"/></div>

              <p></p>
              <b>2. Collector: Mint an Edition</b>
              <p style={{marginTop: '0.5rem'}}>
                A collector mints an edition by sending a transaction to the Immutables.art smart contract. The contract issues an ERC721 token and logs the mint event. Each edition receives a unique transaction hash from its mint transaction, which will be used as the seed to generate that edition's unique artwork.
              </p>
              <div style={{textAlign: 'center'}}><img src={`${process.env.PUBLIC_URL}/2022-01-29-Immutables_v4-Detailed_Diagram_Minter_2.png`} alt="Diagram: Collector mints an edition and receives a token" width="70%"/></div>

              <p></p>
              <b>3. Viewer: View an Edition</b>
              <p style={{marginTop: '0.5rem'}}>
                To display an edition, your browser reads the art script from the Immutables.co transaction log and reads the project and edition data (including the mint transaction hash) from the Immutables.art smart contract. It then runs the art script locally in your browser, using the edition's mint transaction hash as a unique random seed. This means every edition produces a different output from the same code, and the artwork can be regenerated by anyone at any time without relying on any server.
              </p>
              <div style={{textAlign: 'center'}}><img src={`${process.env.PUBLIC_URL}/2022-01-29-Immutables_v4-Detailed_Diagram_Viewer_3.png`} alt="Diagram: Viewer retrieves code and edition data to render artwork" width="70%"/></div>

              </div>
          </Tab>

          <Tab eventKey="about_platform_create_project" title="Artists: Create New Project">
              <div style={{marginTop: '1rem'}}>
              <b>Prototype Your Project</b>
              </div>
              <p style={{marginTop: '0.5rem'}}>
              Use the Project Wizard to prototype your generative art project. The wizard lets you configure your project details, write and preview your p5.js, three.js, vanilla JS, or GLSL art script, style your project's CSS, and draft your info post — all before deploying anything on-chain. Your work is saved automatically in localStorage on the device and browser you are using.
              </p>
              <div className="text-center" style={{marginBottom: '1rem'}}>
                <Button variant="success btn-lg" className="font-display" onClick={this.props.openWizardModal}>launch project wizard</Button>
              </div>
              <MarkdownPreview source={platform.platformCreateProjectText}/>
              <p></p>
              <b>How to Deploy</b>
              <ol>
                <li>Use the <Button variant="link" className="p-0 align-baseline" onClick={this.props.openWizardModal}>Project Wizard</Button> to prototype and refine your project locally until you are satisfied with the result.</li>
                <li>Contact us on <a href="https://discord.gg/A329NUvrAf" target="_blank" rel="noopener noreferrer">Discord</a> to get artist permissions on the Immutables.art contract.</li>
                <li>Once authorized, use the Project Wizard to deploy your code and project on-chain.</li>
                <li>Finish setting up your project using the "Project Settings" menu.</li>
                <li>Request that the project be activated by an admin.</li>
                <li>When you are sure that there are no more last minute changes, lock your project.</li>
                <li>Unpause minting when it is time to drop your generative art series.</li>
              </ol>
              <CreateNewProjectButton
                openWizardModal={this.props.openWizardModal}
                userIsAuthorizedArtist={userIsAuthorizedArtist}
                artistScreeningEnabled={artistScreeningEnabled}/>

          </Tab>

          <Tab eventKey="about_platform_royalties" title="Artists: Royalties">
              <p></p>
              <b>Royalties: 90% to Artist on Primary Sales, and 90% of 10% for Secondary Sales.</b>

              <p></p>
              <b>Trustless Royalty Manager Contract</b>
              <p style={{marginTop: '0.5rem'}}>
                When a project is created, a dedicated Royalty Manager smart contract is deployed with its own Ethereum address. The fee split between artist and platform is set at creation and is immutable — it cannot be changed by anyone, including the platform. The current split is 90% for the artist and 10% for the platform.
              </p>
              <p>
                The Royalty Manager is controlled by the project artist. The artist can update their payout address and configure an additional payee (e.g., a collaborator) with a percentage of their share. All primary and secondary sales revenue flows into this contract and is split automatically according to the immutable fee split. The artist withdraws their funds directly from their Royalty Manager contract — no intermediary is involved.
              </p>

              <p></p>
              <b>EIP-2981 Royalty Standard</b>
              <p style={{marginTop: '0.5rem'}}>
                The Immutables.art contract implements the EIP-2981 royalty standard. Every project has a 10% secondary sales royalty. Of this 10%:
              </p>
              <ul>
                <li>The artist receives 90% of the royalty (9% of the secondary sale price).</li>
                <li>The platform receives 10% of the royalty (1% of the secondary sale price).</li>
              </ul>
              <p>
                Marketplaces that support EIP-2981 will automatically route secondary sale royalties to the project's Royalty Manager contract. For marketplaces that do not support EIP-2981, royalties may be collected at the platform address (<a href="https://etherscan.io/address/0xf1A4A2B73B4913c6e5c318FC5EE3A22C83f46E8C" target="_blank" rel="noopener noreferrer">0xf1A4A2B73B4913c6e5c318FC5EE3A22C83f46E8C</a>) and manually dispersed to the appropriate Royalty Manager contracts.
              </p>
          </Tab>

          <Tab eventKey="standalone_viewer" title="Downloads">
              <p></p>
              <b>The whole site, as one file.</b>
              <p style={{marginTop: '0.5rem'}}>
                <a href="immutablesArtApp.html" download>immutablesArtApp.html</a> is
                this entire interface in a single download &mdash; the grids, museum mode, project
                administration, minting and the Zora marketplace. Save it and open it from your
                computer; no server, no install.
              </p>
              <p style={{marginTop: '0.5rem'}}>
                Viewing works with no connection at all. Anything that writes to Ethereum &mdash;
                minting, admin changes, marketplace listings &mdash; stays visible but is disabled
                while you are offline, and comes back the moment you reconnect.
              </p>

              <p></p>
              <b>Or a smaller one, if you only want the art.</b>
              <p style={{marginTop: '0.5rem'}}>
                <a href="immutablesArt.html" download>immutablesArt.html</a> is
                a tenth of the size, and built for keeping rather than browsing. It holds the art
                scripts, every edition's mint hash, and the p5.js and three.js runtimes. It views
                editions, exports marketplace image sets, and computes trait and rarity stats &mdash;
                with no internet connection, no server, and no dependence on this website continuing
                to exist. When it can reach the chain, it checks for editions minted since it was
                built.
              </p>
              <p style={{marginTop: '0.5rem'}}>
                The artwork is not stored in it as images. Each edition is recomputed from the
                artist's script and that edition's mint transaction hash, exactly as this site does
                it, so the file stays small no matter how many editions a project has.
              </p>

              <p></p>
              <b>How to Use</b>
              <ol>
                <li><a href="immutablesArt.html" download>Download it</a>, then open the saved file from your computer. Do not use your browser's "Save Page As" on a copy that is already open in a tab &mdash; that rewrites the file and it will not run.</li>
                <li><b>View</b> &mdash; pick a project and edition, then render it. Save any edition as a PNG.</li>
                <li><b>Generate images</b> &mdash; render a whole project and download it as ZIP files, for use as marketplace thumbnails.</li>
                <li><b>Stats</b> &mdash; load compiled metadata to see trait distributions and rarity.</li>
              </ol>
              <p style={{marginTop: '0.5rem'}}>
                It renders p5.js projects. Projects written in three.js, plain canvas or GLSL need
                libraries that are not bundled, and are listed but not drawn.
              </p>

              <p></p>
              <b>Generating images without downloading anything</b>
              <p style={{marginTop: '0.5rem'}}>
                The <a href="image-generator.html" target="_blank" rel="noopener noreferrer">image generator</a> does
                the same rendering job in this browser, right now. Artists can use it to produce the
                still images marketplaces display, then host them anywhere and point the project's
                Image Base URL at them.
              </p>

              <p></p>
              <b>Checking a copy before you trust it</b>
              <p style={{marginTop: '0.5rem'}}>
                These files are meant to be copied and passed around, and the whole-site bundle
                connects a wallet &mdash; so a tampered copy is worth guarding against. The
                &nbsp;<a href="https://immutables.art/verify" target="_blank" rel="noopener noreferrer">verify page</a> lists
                the SHA-256 of each download, along with every contract this site can ask you to
                sign a transaction for. If a copy you were handed does not match, do not connect a
                wallet to it.
              </p>
              <p style={{marginTop: '0.5rem'}}>
                That link is deliberately absolute rather than relative: a copy of this page is
                only worth checking against the original, never against a verify page that happened
                to travel alongside it.
              </p>

              <div align="center" style={{display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap'}}>
                <Button variant="outline-success" className="font-display" href="immutablesArtApp.html" download>download the whole site</Button>
                <Button variant="outline-success" className="font-display" href="immutablesArt.html" download>download the art bundle</Button>
                <Button variant="outline-secondary" className="font-display" onClick={() => window.open('image-generator.html', '_blank')}>image generator</Button>
                <Button variant="outline-secondary" className="font-display" onClick={() => window.open('https://immutables.art/verify', '_blank')}>verify a download</Button>
                <Button variant="outline-secondary" className="font-display" href="https://immutables.art/docs/" target="_blank" rel="noopener noreferrer">documentation</Button>

              </div>
          </Tab>

          <Tab eventKey="admin_platform_clear_cache" title="Troubleshooting">
              <p></p>
              <b>Clear Local Storage</b>
              <p style={{marginTop: '0.5rem'}}>
                Blockchain data is cached in your browser's local storage to speed up the interface. If you are seeing stale data or unexpected behavior, clearing this cache and reloading may resolve the issue.
              </p>
              <div align="center">
                <Button variant="warning" className="font-display" onClick={() => {localStorage.clear(); window.location.reload()}}>clear local storage &amp; reload</Button>
              </div>
              <p></p>
              <b>RPC Provider Issues</b>
              <p style={{marginTop: '0.5rem'}}>
                If editions are not loading, your RPC provider may be experiencing issues. Try switching to a different provider in your wallet settings.
              </p>
          </Tab>

          {/*
          <Tab eventKey="about_platform_management" title="Management">
              <p></p>
              <p>The contract is owned by the contract owner who acts as the administrative user.</p>
              <p>The contract owner can delegate administrative functions to a curator.
              The curator may optionally be given a share of the contract revenue after the artists and the artist’s additional payees are paid.</p>
              <p>The contract owner and curator can further delegate a subset of administrative functions to additional team members.</p>
              <p>The contract owner can set a contract beneficiary that may be given a share of the contract revenue after the artist and artist’s
              additional payees are paid.  The contract beneficiary does not have any administrative access to the contract.</p>
          </Tab>*/}
        </Tabs>

        </div>
      </DockPanel>
    );
  }
}

export default AboutPlatformModal;
